export { default as dispatcherQueries } from './basic'